var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrophy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.667 3.333h-1.334V2H4.667v1.333H3.333C2.6 3.333 2 3.933 2 4.667v.666c0 1.7 1.28 3.087 2.927 3.294A3.34 3.34 0 0 0 7.333 10.6v2.067H4.667V14h6.666v-1.333H8.667V10.6a3.34 3.34 0 0 0 2.406-1.973C12.72 8.42 14 7.033 14 5.333v-.666c0-.734-.6-1.334-1.333-1.334zm-9.334 2v-.666h1.334v2.546a2.007 2.007 0 0 1-1.334-1.88zm9.334 0c0 .867-.56 1.6-1.334 1.88V4.667h1.334v.666z"
})));
export default SvgTrophy;